export default "__VITE_ASSET__Cj9SfyYR__"